import React from 'react'

export const Container = ({children}) => {
  return (
    <div className='container'>{children}</div>
  )
}
